import { errorHandler } from "./errorHandler";
import { UserData } from "../interface";
import { apiRequest } from "./apiRequest";

export const editProduct = async (
  id: number,
  args: Partial<UserData>
): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "patch",
      `/products/${id}`,
      { data: args }
    );

    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to update user");
  }
};
